<div
  class="CPI-container"
  [ngStyle]="{ 'background-color': headerCPI.isOpen ? 'white' : '#333' }"
>
  <button
    psUiButton
    id="cpi-dropdown-button"
    class="header-div-h6 position-relative header-dropdown"
    [class.show]="!!headerCPI && headerCPI.isOpen"
    [ngClass]="{
      'dropdown-toggle': !hasMcPreDraftData
    }"
    color="secondary"
    [disabled]="!cpi.length || loading"
    [psUiDropdownToggleFor]="headerCPI"
    (click)="propagateCpiDropdownVisibilityState(true)"
    psUiGtagEvent
    trackOn="click"
    action="cpi"
    category="Black_Bar"
    [params]="{ event_label: 'CPI Dropdown' }"
    data-e2e="cpi-dropdown-toggle-button"
  >
    {{ hasMcPreDraftData ? Constants.AVERAGE_CPI : Constants.CPI }}
  </button>
  <ps-ui-dropdown
    #headerCPI="psUiDropdown"
    class="header-dropdown cpi-dropdown"
    [ngClass]="{
      'header-dropdown-similar': isSimilarProject
    }"
    (isClose)="updateSuppliersCPI($event)"
    [canClose]="!cpiRequireConfirmation"
  >
    <div class="border-bottom">
      <div
        class="row w-100 m-0 header overide_title"
        (click)="avoidClose($event)"
        *psUiConfigEnabled="'overridCmp'"
        data-e2e="cpi-dropdown-price-override-container"
      >
        <div class="tooltip_override">
          <p>Price Override</p>
          <div class="setting-info" [hidden]="!updateCPI">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <p>New CPI value will be applied when you close the dropdown.</p>
          </div>
        </div>
        <div class="d-flex align-items-center header_title">
          <div
            [ngClass]="{
              global_title: loggedInAsServiceBuyer && !enableGlobalPriceOverRide
            }"
            *ngIf="!isPurePriceApplied"
          >
            <ps-ui-slider
              *ngIf="!loggedInAsServiceBuyer || enableGlobalPriceOverRide"
              id="entryLinks"
              (selectedChange)="setEntryLinkFlag($event, 'global')"
              [selected]="globalPriceOveride"
              psUiHotjarEvent
              trackOn="change"
              eventName="Choose Your Supplier - Price Override"
            >
            </ps-ui-slider>
            <span class="selectBtn">Global Price Override</span>
          </div>
          <div
            class="manualCPI_header"
            *ngIf="
              (!loggedInAsServiceBuyer || enableGlobalPriceOverRide) &&
              !isPurePriceApplied
            "
          >
            <label>CPI</label>
            <input
              type="text"
              #globalCpi
              class="form-control"
              step="0.01"
              min="0"
              id="global_override_cpi_value"
              [(ngModel)]="operatorOverrideCpi"
              (keypress)="numberOnly($event, true)"
              (input)="globalCpi.value = operatorOverrideCpi"
              (ngModelChange)="setGlobalOverrideCpi()"
              (click)="setEntryLinkFlag(true, 'global')"
              [ngClass]="{
                'input-error':
                  globalOverrideCpi > this.maxCpiThreshold && globalPriceOveride
              }"
              psUiInputDecimalRestriction
            />
            <br />
          </div>
          <div
            class="serviceBuyer_message"
            *ngIf="
              loggedInAsServiceBuyer &&
              !enableGlobalPriceOverRide &&
              !isPurePriceApplied
            "
          >
            Price override is disabled for WASP operator.
          </div>
          <div class="purePriceApplied_message" *ngIf="isPurePriceApplied">
            CPI Override and Selective Price Override are disable when the
            PurePrice is enabled
          </div>
        </div>
        <div
          *ngIf="
            isMCQBSurvey &&
            globalPriceOveride &&
            (!loggedInAsServiceBuyer || enableGlobalPriceOverRide)
          "
          class="mb-3 d-flex align-items-center"
        >
          <ps-ui-slider
            *ngIf="!loggedInAsServiceBuyer || enableGlobalPriceOverRide"
            id="mcQbGlobalPrice"
            (selectedChange)="setEntryLinkFlag($event, 'mcqbglobal')"
            [selected]="mcQbGlobalPriceOveride"
          >
          </ps-ui-slider>
          <span class="all-locale-text"
            >Apply the same Global Price Override to all locales</span
          >
        </div>
        <div class="d-flex align-items-center header_title">
          <div class="tooltip_override" *ngIf="!isPurePriceApplied">
            <div>
              <ps-ui-slider
                id="entryLinks"
                [disabled]="isAidaEnabled"
                (selectedChange)="
                  loggedInAsServiceBuyer && !enableGlobalPriceOverRide
                    ? setSupplierOverrideFlag($event)
                    : setEntryLinkFlag($event, 'manual')
                "
                [(selected)]="
                  loggedInAsServiceBuyer && !enableGlobalPriceOverRide
                    ? manualSCPIOverrideEnabled
                    : selectivePriceOveride
                "
                psUiHotjarEvent
                trackOn="change"
                eventName="Choose Your Supplier - Selective Manual Override"
                data-e2e="cpi-dropdown-selective-override-slider"
              >
              </ps-ui-slider>
              <span
                class="selectBtn"
                [ngClass]="{ 'disable-btn': isAidaEnabled }"
              >
                Selective Price Override
              </span>
              <ps-ui-aida-feature-unavailable-tooltip
                [isAidaEnabled]="isAidaEnabled"
                class="ms-1"
              ></ps-ui-aida-feature-unavailable-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ps-ui-cpi-override-confirmation
      *ngIf="
        (selectivePriceOveride || globalPriceOveride) &&
        cpiRequireConfirmation &&
        !cpiOverrideConfirmation.state
      "
      [type]="selectivePriceOveride ? 'selective' : 'global'"
      color="pink"
      (confirm)="onCpiOverrideConfirmation($event)"
      [surveyId]="this.surveyId"
      [newCpi]="operatorOverrideCpi"
    ></ps-ui-cpi-override-confirmation>

    <ps-ui-accordion
      [closeOthers]="true"
      (toggle)="similarProjectsAccordionToggle($event)"
    >
      <ps-ui-accordion-section
        [isExpanded]="true"
        class="dependency-accordion supplier-section"
      >
        <ng-template psUiAccordionTitle>Supplier Management</ng-template>
        <ng-template psUiAccordionContent>
          <div (click)="avoidClose($event)">
            <span *psUiConfigEnabled="'enableSupplierGrouping'">
              <ps-ui-select-dropdown
                class="d-block blend-dropdown"
                [dropdownItems]="blendSupplierGroups.listOfOptions"
                [field]="'config_name'"
                [loading]="loadingBlends"
                [enableSearch]="false"
                labelNone="-- Choose Supplier Blend --"
                [(ngModel)]="selectedBlend"
                (selectedItem)="selectBlend($event)"
                psUiHotjarEvent
                trackOn="click"
                eventName="Choose Your Supplier - Supplier Blends"
                data-e2e="cpi-dropdown-supplier-blends-listing"
              >
              </ps-ui-select-dropdown>
            </span>
          </div>
          <div class="table-responsive newtable" (click)="avoidClose($event)">
            <table
              class="table table-borderless m-0"
              data-e2e="cpi-dropdown-supplier-management-table"
            >
              <thead>
                <tr>
                  <th>
                    <input
                      class="checkbox"
                      type="checkbox"
                      [checked]="isSuppliersListChecked"
                      (click)="selectAll($event)"
                    />
                  </th>
                  <th class="w-75" data-name="supplier" [psUiSortTable]="cpi">
                    <div
                      class="form-check form-check-inline m-0 supplier_title"
                    >
                      <label>Supplier</label>
                    </div>
                  </th>
                  <th
                    class="cpi"
                    data-name="cpi"
                    [psUiSortTable]="cpi"
                    *ngIf="selectivePriceOveride || showManualSuppOverride"
                  >
                    <label
                      *ngIf="
                        !loggedInAsServiceBuyer || enableGlobalPriceOverRide
                      "
                      >CPI</label
                    >
                    <label
                      *ngIf="
                        loggedInAsServiceBuyer && !enableGlobalPriceOverRide
                      "
                      >SCPI</label
                    >
                  </th>
                  <th
                    class="feasibility"
                    data-name="feasibility"
                    [psUiSortTable]="cpi"
                  >
                    Feasibility
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of cpi; let $index = index; let $last = last">
                  <td>
                    <input
                      class="checkbox"
                      type="checkbox"
                      name="cpi"
                      [id]="c.id"
                      [checked]="c.selected"
                      (change)="itemChanged($event, c)"
                      [disabled]="!c.isActive"
                    />
                  </td>
                  <td>
                    <div class="form-check form-check-inline m-0 supp-checkbox">
                      <label class="form-check-label custom-check" [for]="c.id">
                        {{ c.supplier | slice : 0 : 40
                        }}{{ c.supplier.length <= 40 ? '' : '...' }}
                        <ps-ui-pds-label
                          *ngIf="c.isPdsApplied"
                          [supplierId]="c.id"
                          [cpi]="c.cpi"
                          [top]="$last"
                          [fee]="c.fee"
                        ></ps-ui-pds-label>
                      </label>
                    </div>
                  </td>

                  <td *ngIf="selectivePriceOveride || showManualSuppOverride">
                    <span (input)="validateManualOverrideRules($index)">
                      <span
                        class="currency-symbol"
                        [class.cpiBoxValue]="!manualSCPIOverrideEnabled"
                      >
                        {{ loggedInAsServiceBuyer ? '$' : currencySymbol }}
                      </span>
                      <input
                        *ngIf="
                          !loggedInAsServiceBuyer || enableGlobalPriceOverRide
                        "
                        type="number"
                        class="form-control"
                        (keypress)="numberOnly($event, true)"
                        (click)="selectInput($event)"
                        (blur)="formatCpi(c.cpi, $index)"
                        [ngModel]="(c.cpi | number : '1.0-2')?.replace(',', '')"
                        (ngModelChange)="c.cpi = $event"
                        [disabled]="
                          globalPriceOveride ||
                          isPurePriceApplied ||
                          !selectivePriceOveride ||
                          !c.selected
                        "
                        [ngClass]="{
                          cpiBoxValue: !selectivePriceOveride,
                          'input-error':
                            c.cpi > this.maxCpiThreshold &&
                            selectivePriceOveride
                        }"
                        psUiInputDecimalRestriction
                        attr.data-e2e="cpi-dropdown-supplier-{{
                          c.id
                        }}-selective-override-input"
                      />
                      <input
                        *ngIf="
                          loggedInAsServiceBuyer &&
                          c.scpi !== undefined &&
                          !enableGlobalPriceOverRide
                        "
                        type="number"
                        class="form-control"
                        (keypress)="numberOnly($event, true)"
                        (click)="selectInput($event)"
                        (blur)="formatCpi(c.scpi, $index, true)"
                        [ngModel]="
                          (c.scpi | number : '1.0-2')?.replace(',', '')
                        "
                        (ngModelChange)="c.scpi = $event"
                        [disabled]="
                          isPurePriceApplied ||
                          !manualSCPIOverrideEnabled ||
                          !c.selected
                        "
                        [ngClass]="{
                          cpiBoxValue: !manualSCPIOverrideEnabled,
                          'input-error':
                            c.scpi > this.maxCpiThreshold &&
                            manualSCPIOverrideEnabled
                        }"
                        psUiInputDecimalRestriction
                      />
                    </span>
                  </td>
                  <td>
                    <div>
                      <span> {{ c.feasibility | zeroDash : '1.0-2' }} </span>
                      <div
                        class="setting-info feasibility-tooltip"
                        *ngIf="c.feasibility && c.unusedQualifications"
                      >
                        <i
                          class="fa fa-exclamation-triangle unused-qual-tooltip-icon"
                          aria-hidden="true"
                        ></i>
                        <p>
                          Unused Qualifications : {{ c.unusedQualifications }}
                        </p>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-template>
        <div class="row m-0 py-0 pt-3 px-5 justify-content-center">
          <button
            id="supplier-allocation-and-details"
            psUiButton
            color="secondary"
            size="small"
            [outline]="true"
            class="py-0 float-end button-text btn-default w-auto"
            (click)="openModal()"
            [disabled]="cpiRequireConfirmation"
            psUiGtagEvent
            trackOn="click"
            action="cpi"
            category="Black_Bar"
            [params]="{ event_label: 'CPI Modal' }"
            data-e2e="cpi-dropdown-supplier-allocation-button"
          >
            Supplier allocation and details
          </button>
        </div>
      </ps-ui-accordion-section>
      <ps-ui-accordion-section
        class="similar-project"
        title="Similar Survey"
        [isExpanded]="isSimilarProjectsLoaded"
        (click)="avoidClose($event)"
        *ngIf="isSimilarProject"
      >
        <div *ngIf="showSimilarProjectPogressBar; else similarProjectsTable">
          <ps-ui-progress-bar
            [label]="progressBarLabel"
            [simulate]="true"
            [threshold]="80"
            [intervalValue]="500"
            [height]="10"
            [progressBarColor]="'#027BFF'"
            [randomIncreament]="false"
            [showInfinityProgressBar]="true"
          ></ps-ui-progress-bar>
          <div class="mt-4 text-center">
            <button class="btn btn-danger" (click)="interruptTheSearch()">
              Interrupt search
            </button>
          </div>
        </div>
        <ng-template #similarProjectsTable>
          <p class="mb-4 text-primary text-center" *ngIf="showResyncButton">
            Similar Survey list is not up to date.
            <button
              class="bg-body border-0 p-0 text-primary fw-bolder"
              (click)="loadSimilarSurveys(true)"
            >
              Re-sync the list
              <span
                ><img
                  class="ms-1 mb-1"
                  src="../../../../../../assets/image/reload-icon.png"
                  width="24px"
                  alt="reload icon"
              /></span>
            </button>
          </p>
          <div *ngIf="similarSurveys.length">
            <ps-ui-table
              [data]="similarSurveys"
              [trackBy]="'ps_survey_id'"
              class="similar-table"
            >
              <ng-container
                psUiTableExpandableRow
                [behavior]="'each'"
                [manualClose]="false"
              >
                <ng-container
                  psUiTableColumn
                  width="fit"
                  psUiTableExpandableRow
                >
                  <ng-template psUiTableColumnCustomHeader>
                    <div class="header-container bold-text text-center">
                      Survey ID
                    </div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div
                      class="content-container justify-content-start survey-id bold-text p-1"
                    >
                      #{{ survey.ps_survey_id }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container psUiTableColumn width="fit">
                  <ng-template psUiTableColumnCustomHeader>
                    <div
                      class="header-container bold-text"
                      style="width: 125px"
                    >
                      Completion Rate
                    </div>
                    <div class="header-container">(Actual/Goal)</div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div
                      class="content-container justify-content-start complition-rate"
                    >
                      {{ survey.fielded }} / {{ survey.completes_required }}
                      <i class="fa fa-caret-right ps-2 pe-2"></i>
                      <span class="actual-goal p-1 bold-text"
                        >{{ getCompletionPercantageRate(survey) }}%</span
                      >
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container
                  psUiTableColumn
                  width="fit"
                  *ngIf="!(loggedInAsServiceBuyer && isEnableTargetMargin)"
                >
                  <ng-template psUiTableColumnCustomHeader>
                    <div class="header-container bold-text">Avg.CPI</div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div class="content-container justify-content-start">
                      {{ survey.currency?.symbol }}
                      {{ survey.cpi | number : '1.2-2' }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container
                  psUiTableColumn
                  width="fit"
                  *ngIf="loggedInAsServiceBuyer && isEnableTargetMargin"
                >
                  <ng-template psUiTableColumnCustomHeader>
                    <div class="header-container bold-text">AVG SCPI</div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div class="content-container justify-content-start">
                      $ {{ survey.avgSCPI || 0 | number : '1.2-2' }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container
                  psUiTableColumn
                  width="fit"
                  *ngIf="loggedInAsServiceBuyer && isEnableTargetMargin"
                >
                  <ng-template psUiTableColumnCustomHeader>
                    <div class="header-container bold-text">AVG Margin</div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div class="content-container justify-content-start">
                      {{ survey.avgMargin || 0 | number : '1.2-2' }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container psUiTableColumn width="fit">
                  <ng-template psUiTableColumnCustomHeader>
                    <div class="header-container bold-text padding-none">
                      EPC
                    </div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div class="content-container justify-content-start">
                      {{ survey.epc }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container psUiTableColumn width="fit">
                  <ng-template psUiTableColumnCustomHeader>
                    <div
                      class="header-container bold-text padding-none ms-1"
                      style="width: 38px"
                    >
                      LOI
                      <ps-ui-custom-tooltip [direction]="'left'">
                        <i
                          psUiTooltipTarget
                          class="fa fa-info-circle text-primary"
                          aria-hidden="true"
                        ></i>

                        <div psUiTooltipContent class="text-white">
                          <p>The LOI is based on the survey overall</p>
                        </div>
                      </ps-ui-custom-tooltip>
                    </div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div class="content-container justify-content-start">
                      {{ survey.loi }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container psUiTableColumn width="fit">
                  <ng-template psUiTableColumnCustomHeader>
                    <div
                      class="header-container bold-text padding-none ms-1"
                      style="width: 30px"
                    >
                      IR
                      <ps-ui-custom-tooltip [direction]="'left'">
                        <i
                          psUiTooltipTarget
                          class="fa fa-info-circle text-primary"
                          aria-hidden="true"
                        ></i>

                        <div psUiTooltipContent class="text-white">
                          <p>The IR is based on the survey overall</p>
                        </div>
                      </ps-ui-custom-tooltip>
                    </div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div class="content-container justify-content-start">
                      {{ survey.ir }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container psUiTableColumn width="fit">
                  <ng-template psUiTableColumnCustomHeader>
                    <div class="header-container bold-text padding-none">
                      Field Time
                    </div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div class="content-container justify-content-start">
                      {{ survey.field_time }}
                    </div>
                  </ng-template>
                </ng-container>
                <ng-container psUiTableColumn width="fit">
                  <ng-template psUiTableColumnCustomHeader>
                    <div class="header-container header-icon ms-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
                        />
                      </svg>
                    </div>
                  </ng-template>
                  <ng-template psUiTableCellTemplate let-survey>
                    <div
                      class="content-container justify-content-start arrow-up-icon row-icon ms-2"
                      (click)="redirectToSurvey(survey.ps_survey_id)"
                      [class.disable-btn]="!isCheckedCompanyId(survey.cmp)"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          d="M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z"
                        />
                      </svg>
                    </div>
                  </ng-template>
                </ng-container>
                <ng-template
                  psUiTableExpandableContent
                  let-survey
                  let-index="index"
                >
                  <div
                    class="d-flex align-items-center"
                    [ngClass]="
                      !!survey.qualifications?.length
                        ? 'justify-content-between'
                        : 'justify-content-end'
                    "
                  >
                    <div
                      class="ps-1 d-flex"
                      *ngIf="!!survey.qualifications?.length"
                    >
                      <span class="criteria-key">Criteria: </span>
                      <span
                        class="criteria-value bold-text ps-1 justify-content-start"
                      >
                        {{ getQualifications(survey, 3) }}
                      </span>
                      <span
                        class="criteria-value bold-text"
                        title="{{ getQualifications(survey) }}"
                        *ngIf="survey.qualifications.length > 3"
                        >, +{{ survey.qualifications?.length - 3 }}</span
                      >
                    </div>
                    <div class="pe-1 d-flex">
                      <span class="criteria-key pe-1">End Date: </span>
                      <span class="criteria-value bold-text">{{
                        (survey.survey_closed_date | date : 'yyyy/MM/dd') ||
                          'NA'
                      }}</span>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
              <ng-template
                psUiTableCaption
                [placement]="'bottom'"
                *ngIf="!similarSurveys.length"
              >
                <div class="no-data">No Similar Survey available.</div>
              </ng-template>
            </ps-ui-table>
          </div>
          <p *ngIf="isClickSurvey()" class="text-center">
            Similar Survey does not take into consideration Click Balanced
            Surveys.
          </p>
          <div
            *ngIf="
              !similarSurveys.length && !showResyncButton && !isSearchCancelled
            "
          >
            <p class="text-center">
              We haven't found any survey that matches your study.
            </p>
            <div
              class="text-center"
              *ngIf="loggedInAsServiceBuyer && !isDoneGlobalSearch"
            >
              <p>Do you want to search outside your account?</p>
              <button
                psUiButton
                color="primary"
                (click)="searchCompanyOutSide()"
              >
                Search outside my account
              </button>
            </div>
          </div>
        </ng-template>
      </ps-ui-accordion-section>
    </ps-ui-accordion>
  </ps-ui-dropdown>
  <div class="mb-0">
    <span
      *ngIf="!loading"
      class="header-div-span"
      [ngStyle]="{ color: headerCPI.isOpen ? 'black' : 'white' }"
    >
      {{ currencySymbol }}
      {{
        hasMcPreDraftData
          ? (averageCPI | number : '1.2-2')
          : (totalCPI | number : '1.2-2')
      }}
    </span>
    <ps-ui-ellipsis-loader [show]="loading"> </ps-ui-ellipsis-loader>
  </div>
</div>
